import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import Vue from 'vue'

// initial state
const state = {
  vereine: [],
  loading: false,
  loaded: false,
  error: null
}

// getters
const getters = {
  vereine (state) {
    return state.vereine
  },
  verein: (state) => (id) => {
    return state.vereine.find(verein => verein.id === id)
  },
  loading (state) {
    return state.loading
  },
  error (state) {
    return state.error
  }
}

// actions
const actions = {
  loadVereine ({commit}) {
    commit('setLoading', true)
    console.log('Vereine laden...')
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).onSnapshot(snapshot => {
      const vereine = snapshot.data()
      commit('setLoadedVereine', vereine)
      commit('setLoading', false)
      commit('setLoaded', true)
    }, (error) => {
      console.log(error)
      commit('setLoading', false)
    })
  },
  createVerein ({commit, getters}, payload) {
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).add(payload)
      .catch((error) => {
        console.log(error)
      })
  // Reach out to firebase and store it
  },
  deleteVereinData ({commit}, payload) {
    commit('setLoading', true)
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).doc(payload).delete()
    .then(() => {
      commit('setLoading', false)
      commit('deleteVerein', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
    commit('setLoading', false)
  },
  updateVereinData ({commit}, payload) {
    commit('setLoading', true)
    const updateObj = {}
    Object.keys(payload).forEach(key => {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key]
      }
    })
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).doc(payload.id).update(updateObj)
    .then(() => {
      commit('setLoading', false)
      commit('updateVerein', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
  }
}

// mutations
const mutations = {
  setLoadedVereine (state, payload) {
    state.vereine = payload
  },
  createVerein (state, payload) {
    state.vereine.push(payload)
  },
  updateVerein (state, payload) {
    const verein = state.vereine.find(verein => {
      return verein.id === payload.id
    })
    Object.keys(payload).forEach(key => {
      if (payload[key]) {
        verein[key] = payload[key]
      }
    })
  },
  deleteVerein (state, payload) {
    let array = state.vereine
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1)
      }
    }
    state.vereine = array
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setLoaded (state, payload) {
    state.loaded = payload
  },
  setError (state, payload) {
    state.error = payload
  },
  clearError (state) {
    state.error = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/verein_alt.js